import PropTypes from 'prop-types';
import React, { useState, useMemo, useRef } from 'react';
import cn from 'classnames';

import styles from './DateOfBirthField.module.scss';

const DateOfBirthField = ({
  onPropertyChange,
  value: DOBValue,
  className,
  name,
  error,
}) => {
  const monthEl = useRef(null);
  const yearEl = useRef(null);

  let existingDay = '';
  let existingMonth = '';
  let existingYear = '';

  if (DOBValue && DOBValue !== 'invalid') {
    [existingDay, existingMonth, existingYear] = DOBValue.split('/');
  }

  const [date, setDate] = useState({
    day: existingDay,
    month: existingMonth,
    year: existingYear,
  });

  const onInputChange = (event) => {
    const reg = /^\d+$/;

    const {
      name: inputName,
      value
    } = event.target;

    if (reg.test(value) || !value) {
      // automatically focus next input
      if (inputName === 'day' && value.length === 2) {
        monthEl.current.focus();
      }

      if (inputName === 'month' && value.length === 2) {
        yearEl.current.focus();
      }

      const dateUpdate = { ...date, [inputName]: value };

      const { day: dayUpdate, month: monthUpdate, year: yearUpdate } = dateUpdate;

      const validDate = dayUpdate && monthUpdate && yearUpdate && yearUpdate.length === 4
        ? `${dayUpdate}/${monthUpdate}/${yearUpdate}`
        : 'invalid';

      if (validDate) {
        onPropertyChange({
          name,
          value: validDate
        });
      }

      setDate(dateUpdate);
    }
  };

  let errorClass;
  let errorsElement = useMemo(() => (
    <div className={styles.containerErrorMessage}>
      <span className={styles.errorMessage} data-hook="register-dob-error">
        {error}
      </span>
    </div>
  ), [error]);

  const {
    day,
    month,
    year,
  } = date;

  if (error.length > 0) {
    errorClass = styles['main--error'];
  } else {
    errorClass = '';
    errorsElement = null;
  }

  const inputClass = cn({
    [styles.input]: true,
    [styles['input--error']]: !!error
  });

  return (
    <div className={`${styles.main} ${errorClass} ${className}`}>
      <div className={styles.containerInputs}>
        <span className={styles.label}>Date of Birth</span>
        <div className={styles.inputs}>
          <input
            type="number"
            name="day"
            data-hook="register-dob-day"
            autoComplete="bday-day"
            className={inputClass}
            onChange={onInputChange}
            maxLength="2"
            placeholder="DD"
            value={day}
          />
          <input
            type="number"
            name="month"
            data-hook="register-dob-month"
            autoComplete="bday-month"
            ref={monthEl}
            className={inputClass}
            onChange={onInputChange}
            maxLength="2"
            placeholder="MM"
            value={month}
          />
          <input
            type="number"
            name="year"
            data-hook="register-dob-year"
            autoComplete="bday-year"
            ref={yearEl}
            className={inputClass}
            onChange={onInputChange}
            maxLength="4"
            placeholder="YYYY"
            value={year}
          />
        </div>
      </div>
      {errorsElement}
    </div>
  );
};

DateOfBirthField.propTypes = {
  onPropertyChange: PropTypes.func,
  error: PropTypes.string.isRequired,
  name: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string,
};

export default DateOfBirthField;
